var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loadingx",rawName:"v-loadingx",value:(_vm.loading),expression:"loading"}],staticClass:"fm-echarts-map"})
}
var staticRenderFns = []

export { render, staticRenderFns }